import { render, staticRenderFns } from "./Schulte5x5.vue?vue&type=template&id=0af2c2e9&scoped=true"
import script from "./Schulte5x5.vue?vue&type=script&lang=js"
export * from "./Schulte5x5.vue?vue&type=script&lang=js"
import style0 from "./Schulte5x5.vue?vue&type=style&index=0&id=0af2c2e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af2c2e9",
  null
  
)

export default component.exports